<template>
  <div class="el-input-number-or-none">
    <el-checkbox
      v-model="checkboxValue"
      border
      @change="onCheckboxChange"
    >
      제한없음
    </el-checkbox>
    <el-input-comma-number
      v-model="numberValue"
      controls-position="right"
      :min="min"
      :max="max"
      :disabled="checkboxValue"
      @change="onNumberChange"
      @input="onNumberInput"
    />
    <span
      v-if="unit"
      class="input-num-unit"
      :class="{'is-disabled': checkboxValue}"
    >
      {{ unit }}
    </span>
  </div>
</template>

<script>
import ElInputCommaNumber from '@/components/element-ui/ElInputCommaNumber';
export default {
  name: 'ElInputNumberOrNone',
  components: {
    ElInputCommaNumber
  },
  props: {
    value: {},
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: 0
    },
    unit: String,
    noneValue: {}
  },
  data() {
    return {
      checkboxValue: false,
      numberValue: 0
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === this.noneValue) {
          this.numberValue = '';
          return (this.checkboxValue = true);
        }

        this.checkboxValue = false;
        return (this.numberValue = value);
      }
    }
  },
  methods: {
    onNumberChange(value) {
      return this.$emit('input', value);
    },
    onNumberInput(value) {
      if (this.checkboxValue) {
        this.$emit('input', this.noneValue);
      } else {
        this.$emit('input', value);
      }
      return;
    },
    onCheckboxChange(value) {
      if (value) {
        return this.$emit('input', this.noneValue);
      }

      return this.$emit('input', this.numberValue);
    }
  }
};
</script>

<style lang="scss">
.el-input-number-or-none {
  display: flex;
  .el-input__inner {
    height: 50px;
    line-height: 50px;
    display: flex;
    font-size: 15px;
    letter-spacing: -0.8px;
    color: #9b9b9b;
    font-weight: 300;
  }

  .el-checkbox {
    margin: auto;
    width: 105px;
    height: 50px;
    border-radius: 6px;
    display: inline-flex;

    .el-checkbox__input {
      margin: auto;
      width: 14px;
      height: 14px;
    }

    .el-checkbox__label {
      margin: auto;
      line-height: 20px;
      font-size: 14px;
      font-weight: normal;
    }
  }

  .el-input-number {
    margin-left: 12px;
    width: calc(100% - 170px);

    &.is-controls-right {
      .el-input__inner {
        padding-left: 0px;
        padding-right: 30px;
      }

      .el-input-number__increase,
      .el-input-number__decrease {
        width: 30px;
        height: auto;
        line-height: 24px;
      }
    }
  }

  .input-num-unit {
    margin-left: 2px;
    display: inline-block;
    width: 50px;
    line-height: 50px;
    text-align: center;

    &.is-disabled {
      color: #d3d3d3;
    }
  }
}
</style>
